import Modal from "components/Modal";
import ModalBody from "components/Modal/ModalBody";
import useTranslation from "hooks/useTranslation";
import closeIcon from "assets/icons/close-outline.svg";
import { getEmailValue } from "utils/email";
import { KeyValueItem } from "./KeyValueItem";

function getEmail(email) {
  const emailString = Array.isArray(email) ? email[0] : email;
  const emailValue = getEmailValue(emailString);

  return emailValue || "--";
}

function UserFormInfoModal({
  setShowUserFormInfoModal,
  showUserFormInfoModal,
  USER_FORM_INIT_V,
  data,
}) {
  const { getTranslation } = useTranslation(["COMMON", "CHAT"]);
  const { t } = getTranslation();

  return (
    <Modal
      visible={showUserFormInfoModal.show}
      setVisibility={setShowUserFormInfoModal}
      className="confirmation-modal"
    >
      <ModalBody>
        <img
          alt="close_modal"
          className="user_form_info_modal_close_icon"
          onClick={() => setShowUserFormInfoModal(USER_FORM_INIT_V)}
          src={closeIcon}
        />

        <div className="user_info_content_wrapper">
          <KeyValueItem k={t("PROFILE").SETTINGS.NAME} v={data?.name} />

          <KeyValueItem k={t("EMAIL")} v={getEmail(data?.email)} />

          <KeyValueItem k={t("PHONE")} v={data?.phone} />

          {data?.info?.map((info_item, idx) => {
            return (
              <KeyValueItem
                key={idx}
                k={info_item?.name}
                v={info_item?.value}
              />
            );
          })}
        </div>
      </ModalBody>
    </Modal>
  );
}

export default UserFormInfoModal;
